// extracted by mini-css-extract-plugin
export default {"content":"absence-insight_content__8kNCD","content__text-card":"absence-insight_content__text-card__Op-8u"};